import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

/* eslint-disable */

Vue.use(VueRouter);
const DEFAULT_TITLE = 'Prometheus · Torn community tools';
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    props: true,
  },
  {
    path: "/commands",
    name: "Commands",
    meta: { title: 'Commands · Prometheus' },
    component: () =>
      import(/* webpackChunkName: "commands" */ "../views/Commands.vue"),
  },
  {
    path: "/join",
    name: "Join",
    meta: { title: 'Community · Prometheus' },
    component: () =>
      import(/* webpackChunkName: "join" */ "../views/Join.vue"),
  },
  {
    path: "/npc-loot/:npcName?",
    name: "NPCLoot",
    meta: { title: 'NPC Loot · Prometheus' },
    component: () =>
      import(/* webpackChunkName: "npcloot" */ "../views/NPCLoot.vue"),
  },
  {
    path: "/travel/:country?",
    name: "Travel",
    meta: { title: 'Travel · Prometheus' },
    component: () =>
      import(/* webpackChunkName: "travel" */ "../views/Travel.vue"),
  },
  {
    path: "/api-reference",
    name: "ApiReference",
    meta: { title: 'API Reference · Prometheus' },
    component: () =>
      import(/* webpackChunkName: "api-reference" */ "../views/ApiReference.vue"),
  },
  {
    path: "/trade",
    name: "Trade",
    meta: { title: 'Trade · Prometheus' },
    component: () =>
      import(/* webpackChunkName: "trade" */ "../views/Trade.vue"),
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/home",
  }
];


const router = new VueRouter({
  mode: 'history',
  routes,
});

router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  Vue.nextTick(() => {
      document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
